<template>
  <div @click="send">
    <slot />
  </div>
</template>
<script>
export default {
  props: {
    type: {
      type: String,
      default: null
    },
    typeId: {
      type: Number,
      default: null
    }
  },
  computed: {
  },
  methods: {
    send () {
      this.$validator.validate().then((result) => {
        if (result) {
          const path = 'messenger'
          this.$router.push(
            this.localePath({
              name: path,
              query: { typeId: this.typeId, type: this.type }
            })
          )
        }
      })
    }
  }
}
</script>
